// extracted by mini-css-extract-plugin
module.exports = {"card":"_5D1lsNP0","buttons":"_5D10A79c"};